import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components';
import { colorGrey60 } from '../../../../../tokens';
import { color } from '../../../../../system';
export var getTableControllerCellOverride = function getTableControllerCellOverride() {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        .TableControllerCell-Trigger {\n            &:hover {\n                background-color: ", ";\n                color: ", ";\n            }\n        }\n    "])), colorGrey60, color('primary.main'));
};